module.exports = {
  "country": "BA",
  "artist": "Hari Mata Hari",
  "song": "Lejla",
  "year": "2006",
  "place": "3",
  "spotify": "7MW40HAIo75bWtAmOrJvFq"
};